import { isGithubActionsAvailable } from '@backstage-community/plugin-github-actions';
import {
  EntityAboutCard,
  EntityLinksCard,
  EntityHasSubcomponentsCard,
  EntitySwitch,
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { Grid } from '@material-ui/core';
import EntityWarningContent from './entity-warning-content';
import { GithubActionsRunsCard } from './github-actions-card';
import { ConfigEditorLink } from './config-editor-link';

export default (
  <Grid container spacing={3} alignItems="stretch">
    {EntityWarningContent}
    <Grid item md={6} xs={12}>
      <EntityAboutCard />
    </Grid>
    <Grid item md={6} xs={12}>
      <ConfigEditorLink />
    </Grid>
    <Grid item md={12} xs={12}>
      <EntityCatalogGraphCard height={400} />
    </Grid>

    <Grid item md={4} xs={12}>
      <EntityLinksCard />
    </Grid>
    <Grid item md={8} xs={12}>
      <EntityHasSubcomponentsCard />
    </Grid>

    <EntitySwitch>
      <EntitySwitch.Case if={isGithubActionsAvailable}>
        <Grid item md={12} xs={12}>
          <GithubActionsRunsCard limit={5} />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
  </Grid>
);
